/* unplugin-vue-components disabled */import { render } from "./BlackHeaven.vue?vue&type=template&id=1db6e55a"
import script from "./BlackHeaven.vue?vue&type=script&lang=js"
export * from "./BlackHeaven.vue?vue&type=script&lang=js"

import "./BlackHeaven.vue?vue&type=style&index=0&id=1db6e55a&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__